import { Col, Container, Row } from "reactstrap";
import {
  Kaaba1Icon,
  Mosque2Icon,
  UserSearch1Icon,
  UserUnlock01Icon,
} from "../../assets/icons";
import { PlatFormCard } from "../../Component/platforms/PlatFormCard";
import { useTranslation } from "react-i18next";
import usePermissions from "../../utils/hooks/usePermissions";
import { NoAccess } from "../../CommonElements/NoAccess";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";

export const Platforms = () => {
  const { t } = useTranslation();
  const {
    user,
    canAccessMakkah,
    canAccessMadina,
    canAccessSeasonalHR,
    canAccessUserManagement,
    hasAnyPermission
  } = usePermissions()
  const { getLocalizedText } = useLocalizedText();

  const noAccess =
    !canAccessMakkah() &&
    !canAccessMadina() &&
    !canAccessSeasonalHR() &&
    !canAccessUserManagement();

  if (noAccess) {
    return (
      <div
        className="decorative-arabic-text-bg"
        style={{ flexGrow: 1, paddingTop: "32px" }}
      >
        <NoAccess title={t("PLATFORMS")} />
      </div>
    );
  }

  return (
    <div
      className="decorative-arabic-text-bg"
      style={{ flexGrow: 1, paddingTop: "32px" }}
    >
      <Container>
        <div style={{ marginBottom: "4rem" }}>
          <h1 style={{ fontSize: "2rem" }}>
            {t("LOGIN_WELCOME", { name: getLocalizedText(user?.name_ar, user?.name_en) })}
          </h1>
          <p style={{ maxWidth: "499px", fontWeight: "600", fontSize: "1rem" }}>
            {t("APP_DESCRIPTION")}
          </p>
        </div>

        <Row>
          {canAccessMakkah() && (
            <PlatFormCol>
              <PlatFormCard
                title={t("MECCA_HAJJ_MANAGEMENT_PLATFORM")}
                description={t("HAJ_PLATFORM_DESCRIPTION")}
                icon={<Kaaba1Icon />}
                link="/app/makkah"
              />
            </PlatFormCol>
          )}

          {canAccessMadina() && (
            <PlatFormCol>
              <PlatFormCard
                title={t("MADINAH_HAJJ_MANAGEMENT_PLATFORM")}
                description={t("MADINA_PLATFORM_DESCRIPTION")}
                icon={<Mosque2Icon />}
                link="madina"
              />
            </PlatFormCol>
          )}

          {canAccessSeasonalHR() && (
            <PlatFormCol>
              <PlatFormCard
                title={t("SEASONAL_RECRUITMENT_PLATFORM")}
                description={t("RECRUITMENT_PLATFORM_DESCRIPTION")}
                icon={<UserSearch1Icon />}
                link="seasonal_hr"
              />
            </PlatFormCol>
          )}

          {canAccessUserManagement() && (
            <PlatFormCol>
              <PlatFormCard
                title={t("USER_PERMISSIONS_MANAGEMENT_PLATFORM")}
                description={t(
                  "USER_PERMISSIONS_MANAGEMENT_PLATFORM_DESCRIPTION"
                )}
                icon={<UserUnlock01Icon />}
                link="/app/user_management/users"
              />
            </PlatFormCol>
          )}
        </Row>
      </Container>
    </div>
  );
};

const PlatFormCol = ({ children }) => (
  <Col xs="12" lg="6" className="staggered">
    {children}
  </Col>
);
